export enum WalletPlatform {
  NEON = 'neon',
  NEOLINE = 'neoline',
}
